module.exports = __webpack_public_path__ + "img/11087925_L.d2bbde15.png";